module.exports = __webpack_public_path__ + "static/media/screenshot(32).95c75c6e.jpg";